import { render, staticRenderFns } from "./marketingShop.vue?vue&type=template&id=beb27f94&scoped=true"
import script from "./marketingShop.vue?vue&type=script&lang=js"
export * from "./marketingShop.vue?vue&type=script&lang=js"
import style0 from "./marketingShop.vue?vue&type=style&index=0&id=beb27f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb27f94",
  null
  
)

export default component.exports